import { render, staticRenderFns } from "./CardCreateNegotiationAction.vue?vue&type=template&id=96ce15fe"
import script from "./CardCreateNegotiationAction.vue?vue&type=script&lang=js"
export * from "./CardCreateNegotiationAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports